import { Injectable } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common'


@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(public datepipe: DatePipe) { }

  calendarDateChanged(calendarDate: Date | null, calendar: Calendar, table: Table, field: string, comparisonMethod: string, dateFormat: string) {
      setTimeout(() => {
      const calendarInput = calendar?.el.nativeElement.querySelector('input');
      if (calendarInput) {
        const enteredValue = calendarInput.value;
        if (calendarDate || enteredValue === '') {
          const newDate = this.datepipe.transform(enteredValue === '' ? null : calendar.value, dateFormat);
          table.filter(newDate, field, comparisonMethod);
        }
      }
    }, 1);
  }
}
